export default function validateTicket(values) {
    let errors = {};

    if (!values.ticketCount || parseInt(values.ticketCount, 10) < 1) {
        errors.ticketCount = "*At least 1 ticket required."
    } else {
        errors.ticketCount = ""
    }

    return errors;
}
